import {client} from './client'
import Collection from '../models/collection'

export default {
  index (query) {
    return client.get('/collections?include=sequences', {
      params: query
    })
  },
  show (id) {
    return client.get('/collections/' + id)
      .then((response) => {
        return new Collection(false, response.data.data)
      })
  },
  sequences (id, query) {
    return client.get('/collections/' + id + '/sequences', {
      params: query
    })
  },
  store (data) {
    return client.post('/collections', data.prepareForSend())
  },
  update (id, data) {
    return client.patch('/collections/' + id, data.prepareForSend())
  },
  search (data, query) {
    return client.get('/collections', {
      params: {
        filter: JSON.stringify(data),
        limit: query.limit,
        ascending: query.ascending,
        page: query.page,
        byColumn: query.byColumn,
        orderBy: query.orderBy
      }
    })
  },
  select (data) {
    let collection = new Collection(true)
    collection.nome = data
    return client.get('/collections', {
      params: {
        filter: JSON.stringify(collection),
        limit: 100,
        orderBy: 'title'
      }
    })
  },
  delete (id) {
    return client.delete('/collections/' + id)
  },
  detachSequence (collection, sequence) {
    return client.delete('collections/' + collection + '/sequences/' + sequence)
  }
}



// WEBPACK FOOTER //
// ./src/api/collections.js